export enum HTTPStatusesEnum {
    Unauthorized = 401,
    Forbidden = 403,
    ExpiredLink = 454,
    InvalidLink = 452,
    ServerError = 500,
    WrongOldPassword = 453,
    ForbiddenReusePassword = 458,
}
